const queries = {
  'Popular': {sort: 'popular'},
  'Following': {following: 'true'}
};

export function normalizeForumQuery(query) {
  let normalizedQuery = query;

  if(Object.keys(query).length == 0) {
    normalizedQuery = queries['Popular'];
  }

  if(normalizedQuery.topic) {
    normalizedQuery = {
      ...normalizedQuery,
      sort: 'recent'
    };
  }

  return normalizedQuery;
}

export function getQueryTitle(query) {
  if(query.topic) {
    return query.title;
  }

  const queriesTitles = Object.keys(queries);

  for(let i = 0; i < queriesTitles.length; i++) {
    const queryTitle = queriesTitles[i];

    if(JSON.stringify(normalizeForumQuery(queries[queryTitle])) === JSON.stringify(normalizeForumQuery(query))) {
      return queryTitle;
    }
  }

  return null;
}

export default queries;



/** WEBPACK FOOTER **
 ** ./src/members/__shared__/forumQueries.js
 **/